import React, { useEffect, useState } from "react";
import LeadsTable from "../Table/LeadsTable";
import LeadsFilterSearch from "./LeadsFilterSearch";

import { Alert, AlertTitle, Grid } from "@mui/material";
import LeadersSearchHeader from "./LeadersSearchHeader";
import {
  deferralFilterAction,
  deferralLeadFindAction,
  deferralLeadWithoutPaginationFindAction,
  deleteLeadAction,
  leadFindAction
} from "../../actions/leadActions/leadActions";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import usePrivilegeCheck from "../../constants/customHooks/UsePrivilegeCheck";
import { findUserAction } from "../../actions/adminAuthAction";
import DownloadExcel from "../extraComponents/DownloadExcel";
import DownloadPdf from "../extraComponents/DownloadPdf";
import axios from "axios";
import Loader from "../LoaderComponent/Loader";
import TableNoItemComponent from "../customComponent/TableNoItemComponent";

function LeadDead(props) {
  const dispatch = useDispatch();
  const [filterPassData, setFilterPassData] = useState();
  const [whichFilter, setwhichFilter] = useState();
  const [reset, setReset] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [data, setData] = useState([]);
  const [paginationPageNumber, setPaginationPageNumber] = useState(1);
  const [pagiantionEntry, setPagiantionEntry] = useState(25);
  const [viewedColumn, setViewedColumn] = useState([])
  const [columnVisibilityData, setColumnVisibilityData] = useState([])
  const [searchPagination, setSearchPagination] = useState(false)
  const [searchPaginationCount, setSearchPaginationCount] = useState(0)
  const [filterPagination, setFilterPagination] = useState(false)
  const [currentFilterData, setCurrentFilterData] = useState(null);
  const [searchValue, setSearchValue] = useState('');

  const { privilege, hasPrivilege } = usePrivilegeCheck();

  const { deferralLeadFindLoading, deferralLeadFindSuccess } = useSelector((state) => state.deferralLeadFind)

  const { deferralLeadWithoutPaginationFindSuccess } = useSelector((state) => state.deferralLeadFindWithoutPagination)

  const { deferralFilterSuccess } = useSelector((state) => state.deferralFilter)
  
  let { leadAddSuccess } = useSelector((state) => {
    return state.leadAdd;
  });

  let { leadDeleteSuccess } = useSelector((state) => {
    return state.deleteLead;
  });

  let { leadOwnerSuccess } = useSelector((state) => {
    return state.leadOwnerChange;
  });

  let { loginFindSuccess } = useSelector((state) => {
    return state.findUser;
  });

  useEffect(() => {
    dispatch(findUserAction());
  }, [dispatch]);

  // useEffect(() => {
  //   dispatch(leadFindAction());
  // }, [dispatch, leadAddSuccess, leadDeleteSuccess, leadOwnerSuccess]);

  useEffect(() => {
    if (!searchPagination && !filterPagination || leadOwnerSuccess) {
      dispatch(deferralLeadFindAction(pagiantionEntry, paginationPageNumber))
      dispatch(deferralLeadWithoutPaginationFindAction())
    }
  }, [
    dispatch,
    leadAddSuccess,
    leadDeleteSuccess,
    leadOwnerSuccess,
    pagiantionEntry,
    paginationPageNumber,
    searchPagination,
    filterPagination
  ])

  useEffect(() => {
    if (deferralLeadFindSuccess || reset) {
      // setLeadData(
      //   deferralLeadFindSuccess?.allLeads?.filter((data) => data.status === "deferral")
      // );
      setLeadData(deferralLeadFindSuccess?.allLeads)
    }
  }, [deferralLeadFindSuccess, reset]);

  useEffect(() => {
    if(deferralFilterSuccess || reset) {
      setFilterPagination(true);
      setPaginationPageNumber(1);
      setLeadData(deferralFilterSuccess?.allLeads)
    }
  }, [deferralFilterSuccess, reset])

  useEffect(() => {
    const columnVisibilityData = columns.filter((col) => {
      if (viewedColumn.includes(col.field)) {
        return col
      }
    })
    setColumnVisibilityData(columnVisibilityData)
  }, [viewedColumn])

  useEffect(() => {
    setData(
      leadData?.map((lead, index) => ({
        id: lead.id,
        sl: index + 1,
        name: lead.firstName,
        email: lead.email,
        phone: lead.mobileNumber,
        whatsappNumber: lead.whatsappNumber,
        status: lead.status,
        leadSource: lead.leadSource,
        leadCity: lead.location,
        prefferedCountry: lead.preferredCountryId,
        leadBranch: lead?.branch_master?.branchName
          ? lead?.branch_master?.branchName
          : "-",
        leadCounsilor:
          loginFindSuccess?.role?.roleName !== "counsellor"
            ? lead?.counsilorID
              ? lead?.counsilorID
              : "-"
            : null,
        leadTeleCaller:
          loginFindSuccess?.role?.roleName !== "tele caller"
            ? lead?.teleCallerId
              ? lead?.teleCallerId
              : "-"
            : null,
        intakeMonth: lead.status == "deferral" ? lead?.deferalIntakeMonth : "-",
        intakeYear: lead.status == "deferral" ? lead?.deferalIntakeYear : "-"
      }))
    );
  }, [leadData]);

  const handleSearchChange = (e) => {
    try {
      const newSearchValue = e.target.value.trim()
      setSearchValue(newSearchValue);

      if (newSearchValue === "") {
        setSearchPagination(false);
        setLeadData(deferralLeadFindSuccess?.allLeads);
        return;
      }

      setPaginationPageNumber(1)

    } catch (error) {
      console.error(error);
    }
  }

  const searchHandleChange = async (e) => {
    try {
      const newSearchValue = e.target.value.trim();

      if (newSearchValue === "") {
        setSearchPagination(false);
        dispatch(deferralLeadFindAction(pagiantionEntry, paginationPageNumber));
        return;
      }

      setSearchValue(newSearchValue);
      setSearchPagination(true);
      setFilterPagination(false);
      
      fetchSearchResults(newSearchValue, paginationPageNumber);

      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/lead/searchdeferrallead?q=${searchValue}&
      limit=${pagiantionEntry}&pagenumber=${paginationPageNumber}&id=${UserId}`, config)

      setSearchPaginationCount(data?.totalCount)
      setLeadData(data?.payload)
    } catch (error) {
      console.error(error);
    }
  }

  const fetchSearchResults = async (value, pageNum) => {
    try {
      let isUserExist = localStorage.getItem("loginInfo")
        ? JSON.parse(localStorage.getItem("loginInfo"))
        : null;

      const config = {
        headers: {
          Authorization: `Bearer ${isUserExist?.token}`,
        },
      };

      let UserId = isUserExist?.UserId;

      const { data } = await axios.get(`/api/admin/lead/searchdeferrallead?q=${value}&
          limit=${pagiantionEntry}&pagenumber=${pageNum}&id=${UserId}`, config)

      setSearchPaginationCount(data?.totalCount);
      setLeadData(data?.payload);
    } catch (error) {
      console.error(error);
    }
  };
  
  const [leadId, setLeadId] = useState([]);
  const [ids, setIds] = useState([]);

  // material Table
  // material Table
  const columns = [
    {
      title: "Sl no",
      field: "sl"
    },
    {
      title: "Name",
      field: "name",
      // hidden: showNameColumn
    },
    {
      title: "Email",
      field: "email",
      // hidden: showEmailColumn
    },
    {
      title: "Phone",
      field: "phone",
      // hidden: showPhoneColumn
    },
    {
      title: "What's App Number",
      field: "whatsappNumber",
      // hidden: showWhatsAppNumColumn
    },

    {
      title: "Lead Source",
      field: "leadSource",
      // hidden: showLeadSourceColumn
    },
    {
      title: "Lead Place",
      field: "leadCity",
      // hidden: showLeadPlaceColumn
    },
    {
      title: "Preferred Country",
      field: "preferredCountry",
    },
    {
      title: "Lead Branch",
      field: "leadBranch",
    },
    {
      title: "Deferal Intake month",
      field: "DeferalIntakeMonth",
      filtering: false,
      // hidden: showReasonColumn
    },

    {
      title: "Deferal Intake year",
      field: "DeferalIntakeYear",
      filtering: false,
      // hidden: showReasonColumn
    },

    {
      title:
        loginFindSuccess?.role == null ||
          loginFindSuccess?.isManager ||
          loginFindSuccess?.role?.roleName !== "tele caller"
          ? "TeleCaller"
          : null,
      field: "TeleCaller",
      // hidden: showTelecallerColumn
    },
    {
      title:
        loginFindSuccess?.role == null ||
          loginFindSuccess?.isManager ||
          loginFindSuccess?.role?.roleName !== "counsellor"
          ? "Counsilor"
          : null,
      field: "Counsilor",
      // hidden: showCounsilorColumn
    },

    {
      title: "Action",
      field: "action",
      filtering: false
    }
  ];

  const excelDownloadClick = () => {
    const excludedFields = ["action"];
    const filteredColumns = columns.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    ); 

    DownloadExcel(filteredColumns, data, "deferral_Managment");
  };

  const pdfDownloadClick = () => {
    const excludedFields = ["action"];
    const filteredColumns = columns.filter(
      (column) =>
        !excludedFields.includes(column?.field)
    ); 

    DownloadPdf(filteredColumns, data, "Defferal_Management", "Defferal Lead Details")
  }

  const toggleNameColumn = (status, columnName) => {
    setViewedColumn((prevColumns) => {
      if (status) {
        return prevColumns.includes(columnName) ? prevColumns : [...prevColumns, columnName];
      } else {
        return prevColumns.filter((col) => col !== columnName);
      }
    });
  };

  const LeadFilterFunction = (filterData) => {
    try {
      setCurrentFilterData(filterData);
      setSearchPagination(false);
      setFilterPagination(true);
      setPaginationPageNumber(1);
      dispatch(deferralFilterAction(filterData, pagiantionEntry, 1))
    } catch (error) {
      console.error(error)
    }
  }

  const handleResetData = (status) => {
    setwhichFilter(null);
    setFilterPassData(null);
    setReset(!reset);
    setwhichFilter(null);
    setFilterPassData(null);
    setPaginationPageNumber(1);
    setSearchPagination(false);
    setFilterPagination(false);
    setSearchValue('');
    setCurrentFilterData(null);
    dispatch(deferralLeadFindAction(pagiantionEntry, 1));
  };

  const handlePaginationEntry = (e) => {
    let value = e.target.value;
    setPagiantionEntry(value);

    setPaginationPageNumber(1);

    if (searchPagination && searchValue) {
      fetchSearchResults(searchValue, 1);
    } else if (filterPagination && currentFilterData) {
      dispatch(deferralFilterAction(currentFilterData, value, 1));
    } else {
      dispatch(deferralLeadFindAction(value, 1));
    }
  };

  const setIdsFunction = (leadsId) => {
    setLeadId(leadsId);
  };
  const handleDeleteClick = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteLeadAction(leadId));
      }
    });
  };

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const paginationDataFetching = (pageNumber) => {
    try {
      setPaginationPageNumber(pageNumber);

      if (searchPagination && searchValue) {
        fetchSearchResults(searchValue, pageNumber);
      } else if (filterPagination && currentFilterData) {
        dispatch(deferralFilterAction(currentFilterData, pagiantionEntry, pageNumber));
      } else {
        dispatch(deferralLeadFindAction(pagiantionEntry, pageNumber));
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (!hasPrivilege("Defferal") && privilege !== null) {
    return (
      <Alert severity="error">
        <AlertTitle>warning</AlertTitle>
        You don't have permission to access — <strong>this page.!</strong>
      </Alert>
    );
  }
  return (
    <>
      <LeadersSearchHeader
        columnVisibleHandler={toggleNameColumn}
        excelDownloadClick={excelDownloadClick}
        pdfDownloadClick={pdfDownloadClick}
        filterPassData={filterPassData ? filterPassData : null}
        whichFilter={whichFilter ? whichFilter : null}
        handleResetData={handleResetData}
        handleDeleteClick={handleDeleteClick}
        searchHandleChange={searchHandleChange}
        ids={ids}
        leadId={leadId}
        component="leadDeferral"
        subMenu="Defferal"
        column={columns}
        viewedColumn={viewedColumn}
        handleSearchChange={handleSearchChange}
      />
      {/* <div style={{display:"flex",justifyContent:"space-evenly", width:"auto"}}> */}
      <Grid container spacing={-3} sx={{ mt: "-31px" }}>
        <Grid item xs={12} md={2} lg={2.2}>
          <LeadsFilterSearch
            LeadFilterFunction={LeadFilterFunction}
            handleResetData={handleResetData}
            statusComponent="leadDeferral"
            data={deferralLeadWithoutPaginationFindSuccess?.allLeads}
            pagiantionEntry={pagiantionEntry}
            handlePaginationEntry={handlePaginationEntry}
          />
        </Grid>
        <Grid item xs={12} md={10} lg={9.8}>
          {deferralLeadFindLoading ? (
            <Loader />
          ) : data?.length === 0 ? (
            <TableNoItemComponent />
          ) : (
            <LeadsTable
              toggle={props.toggle}
              // showNameColumn={showNameColumn}
              // showEmailColumn={showEmailColumn}
              // showPrefferedColumn={showPrefferedColumn}
              // showPhoneColumn={showPhoneColumn}
              // showWhatAppNumberColumn={showWhatsAppNumColumn}
              // showLeadSourceColumn={showLeadSourceColumn}
              // showLeadBranchColumn={showLeadBranchColumn}
              // showLeadPlaceColumn={showLeadPlaceColumn}
              // showReasonColumn={showReasonColumn}
              // showTelecallerColumn={showTelecallerColumn}
              // showCounsilorColumn={showCounsilorColumn}
              reset={reset}
              setIdsFunction={setIdsFunction}
              data={data}
              columns={columnVisibilityData.length > 0 ? columnVisibilityData : columns}
              // leadFindLoading={leadFindLoading}
              selectBoxIdPassHandler={selectBoxIdPassHandler}
              isExistCounsilor={loginFindSuccess}
              component="leadDeferral"
              pagiantionEntry={pagiantionEntry}
              paginationPageNumber={paginationPageNumber}
              subMenu="Defferal"
              mainMenu="Deals"
              viewedColumn={viewedColumn}
              // totalLeadCount={searchPagination ? searchPaginationCount : deferralLeadFindSuccess?.totalCount}
              totalLeadCount={
                searchPagination ? searchPaginationCount : 
                filterPagination ? deferralFilterSuccess?.totalCount :
                deferralLeadFindSuccess?.totalCount
              }
              paginationDataFetching={paginationDataFetching}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default LeadDead;
